<template>
    <div class="container bg-light mt-5">
        <div class="row" style="padding: 20px 0;">
            <div class="col-12 col-md-6 mb-3">
            	<div class="form-row">
            		<div id="a-1" class="form-group col-md-12 col-lg-6 form-item--with-scaling-label form-item" :class='editProduct ? "form-item--input-filled": ""' v-on:click="addLabelClass">
					    <label class="form-item__label">Név</label>
					    <input type="text" id="nameHU" v-on:blur="removeLabelClass" class="form-control" v-model="nameHU" autocomplete="off" v-on:change="setLink($event.target.value, 'HU')">
					</div>
					<div id="b-1" class="form-group col-md-12 col-lg-6 form-item--with-scaling-label form-item" :class='editProduct ? "form-item--input-filled": ""' v-on:click="addLabelClass">
					    <label class="form-item__label">Link</label>
					    <input type="text" id="linkHU" v-on:blur="removeLabelClass" class="form-control" v-model="linkHU" autocomplete="off">
					</div>
					<div id="d-1" class="form-group col-md-12 col-lg-6 form-item--with-scaling-label form-item" :class='editProduct ? "form-item--input-filled": ""' v-on:click="addLabelClass">
					    <label class="form-item__label">Anyag</label>
					    <input type="text" id="materialHU" v-on:blur="removeLabelClass" class="form-control" v-model="materialHU" autocomplete="off">
					</div>
					<div class="form-group col-md-12">
						<label for="">Egyéb info</label>
						<Editor id="textHU" @messageFromChild="receivedMessage" v-model="textHU"></Editor>
					</div>
            	</div>
            </div>
            <div class="col-12 col-md-6">
            	<div class="form-row">
            		<div id="a-2" class="form-group col-md-12 col-lg-6 form-item--with-scaling-label form-item" :class='editProduct ? "form-item--input-filled": ""' v-on:click="addLabelClass">
					    <label class="form-item__label">Name</label>
					    <input type="text" id="nameEN" v-on:blur="removeLabelClass" class="form-control" v-model="nameEN" autocomplete="off" v-on:change="setLink($event.target.value, 'EN')">
					</div>
					<div id="b-2" class="form-group col-md-12 col-lg-6 form-item--with-scaling-label form-item" :class='editProduct ? "form-item--input-filled": ""' v-on:click="addLabelClass">
					    <label class="form-item__label">Link</label>
					    <input type="text" id="linkEN" v-on:blur="removeLabelClass" class="form-control" v-model="linkEN" autocomplete="off">
					</div>
					<div id="d-2" class="form-group col-md-12 col-lg-6 form-item--with-scaling-label form-item" :class='editProduct ? "form-item--input-filled": ""' v-on:click="addLabelClass">
					    <label class="form-item__label">Material</label>
					    <input type="text" id="materialEN" v-on:blur="removeLabelClass" class="form-control" v-model="materialEN" autocomplete="off">
					</div>
					<div class="form-group col-md-12">
						<label for="">More info</label>
						<Editor id="textEN" @messageFromChild="receivedMessage" v-model="textEN"></Editor>
					</div>
            	</div>
            </div>
            <div class="col-12">
            	<hr>
            	<div class="row">
            		<div class="form-group col-md-3 col-12">
            			<label for="typeEN">Category:</label>
                		<select id="typeEN" v-model="typeEN" class="form-control" v-on:change="setCategory($event.target.value)">
						  	<option value="bows">Bows</option>
						  	<option value="arrows">Arrows</option>
						  	<option value="quivers">Quivers</option>
						  	<option value="targets">Targets</option>
						  	<option value="protective-equipments">Protective Equipments</option>
						  	<option value="others">Others</option>
						</select>
                	</div>
                	<div class="col-12 col-md-3">
                		<label>Subcategory:</label>
	                    <select v-model="finalType" class="form-control" v-bind:disabled="isSubCategory ? false : true">
	                        <option :value="index" v-for="(item, index) in subCategory" v-bind:key="index">{{ index }}</option>
	                    </select>
	                </div>
                	<div class="col-md-3 col-12 position-relative">
				  		<label for="img">Select image:</label>
						<input class="position-absolute" type="file" id="img" name="img" accept="image/*"  v-on:change="set_filename()">
						<p class="fileName form-control" v-text="img_file ? img_file: 'Your image file name'"></p>
				  	</div>
            	</div>
            	<div class="row">
					<div id="c-1" class="form-group col-md-12 col-lg-3 form-item--with-scaling-label form-item" :class='editProduct ? "form-item--input-filled": ""' v-on:click="addLabelClass">
					    <label class="form-item__label">Ár</label>
					    <input type="text" id="priceHU" v-on:blur="removeLabelClass" class="form-control" v-model="priceHU" autocomplete="off">
					</div>
					<div class="form-group col-md-6">
				    	<div class="form-check mt-2">
				      		<input class="form-check-input" type="checkbox" id="visible-check" v-model="visible">
			      			<label class="form-check-label" for="gridCheck">
			        			Is this item visible?
			      			</label>
			    		</div>
				  	</div>
				</div>
				<div class="row">
					<div id="x-1" class="form-group col-md-12 col-lg-4 form-item--with-scaling-label form-item" :class='editProduct ? "form-item--input-filled": ""' v-on:click="addLabelClass">
					    <label class="form-item__label">Manufacturer</label>
					    <input type="text" id="manufacturer" v-on:blur="removeLabelClass" class="form-control" v-bind:disabled="manufacturer_input ? false : true" v-model="manufacturer">
					</div>
					<div id="x-2" class="form-group col-md-12 col-lg-4 form-item--with-scaling-label form-item" :class='editProduct ? "form-item--input-filled": ""' v-on:click="addLabelClass">
					    <label class="form-item__label">Strength</label>
					    <input type="text" id="strength" v-on:blur="removeLabelClass" class="form-control" v-bind:disabled="strength_input ? false : true"  v-model="strength">
					</div>
					<div id="x-3" class="form-group col-md-12 col-lg-4 form-item--with-scaling-label form-item" :class='editProduct ? "form-item--input-filled": ""' v-on:click="addLabelClass">
					    <label class="form-item__label">Size</label>
					    <input type="text" id="size" v-on:blur="removeLabelClass" class="form-control" v-bind:disabled="size_input ? false : true"  v-model="size">
					</div>
				</div>
				<div class="text-center">
				  	<button type="submit" v-if="!editProduct" v-on:click="sendDataToDB" class="btn bg-dark upload-btn text-white">Upload!</button>
				  	<button type="button" v-if="editProduct" v-on:click="updateDataInDB(editProduct_type,editProduct_id)" class="btn bg-dark upload-btn text-white">Edit!</button>
				</div>
            </div>
        </div>
    </div>
</template>

<script>
	import Compressor from 'compressorjs';
	import Editor from './Editor.vue';
	import { Bus }  from "../bus.js";
	import firebase from 'firebase';
	import { convertToLink, getCurrentDate } from '../functions.js';

    export default{
    	data: function () {
      		return {
	      		database : firebase.database(),
	      		storageRef : firebase.storage().ref(),
	      		typeEN: null,
	      		finalType: null,
	      		isSubCategory: false,
	      		subCategory: null,
	      		nameHU: "",
	      		nameEN: "",
	      		materialHU: "",
	      		materialEN: "",
	      		linkHU : "",
			    linkEN: "",
			    textHU: "",
			    textEN: "",
			    priceHU: "",
			    manufacturer: "",
			    size: "",
			    strength: "",
			    manufacturer_input: true,
			    size_input: true,
			    strength_input: true,
			    img_file: "",
			    editProduct: false,
	      		editProduct_id: "",
	      		editProduct_type: "",
	      		visible: false
	    	}
	  	},
	  	components: {
		    Editor
		},
		watch: {
            finalType: function (val) {
                this.finalType = val;
            }
        },
		mounted: function(){
	  		var self = this;
	    	Bus.$on("product", (type,subCategory,id) => {
				if(subCategory != ""){
					self.isSubCategory = true;
					self.editProduct_type = type;
					self.setCategory(type);
                    self.getDataFromDB(type,subCategory, id);
                }else{
					self.editProduct_type = type;
					self.getDataFromDB(type,"", id);
                }
                self.editProduct = true;
				self.editProduct_id = id;
			});
	  	},
	  	watch: {
	  		typeEN: function(){
	  			switch(this.typeEN) {
	  				case "bows":
				    	this.size_input = false;
				    	this.strength_input = true;
				    	this.manufacturer_input = false;
				    	break;
				  	case "arrows":
				    	this.size_input = false;
				    	this.strength_input = true;
				    	this.manufacturer_input = true;
				    	break;
				 	case "quivers":
				    	this.strength_input = false;
				    	this.manufacturer_input = false;
				    	this.size_input = true;
				    	break;
				  	case "targets":
				    	this.strength_input = false;
				    	this.size_input = true;
				    	this.manufacturer_input = false;
				    	break;
				    case "protective-equipments":
				    	this.strength_input = false;
				    	this.size_input = true;
				    	this.manufacturer_input = false;
				    	break;
				  	default:
				    	this.size_input = false;
				    	this.strength_input = false;
				    	this.manufacturer_input = false;
				}
	  		}
	  	},
	  	methods: {
	  		addLabelClass: function(event){
	  			let selector = event.target.parentNode.id;
	  			document.getElementById(selector).classList.add("form-item--input-filled");
	  		},
	  		removeLabelClass: function(event){
	  			let selector = event.target.parentNode.id;
	  			let input_value = event.target.value;

	  			if(input_value === '') {
			        document.getElementById(selector).classList.remove("form-item--input-filled");
			    }
	  		},
	  		setLink: function(linkName, lang){
	  			linkName = convertToLink(linkName);

	  			if(lang == "HU"){
                	this.linkHU = linkName;
                }else{
                	this.linkEN = linkName;
                }
	  		},
	  		set_filename: function(){
  				let img = document.getElementById("img").value;
    			let part = img.split("\\");
	    		this.img_file = part[2];
	  		},
	  		setCategory: function(type){
	  			let self = this;
                
            	if(type == "bows"){

            		let dbRef = this.database.ref('products/bows/');
		            dbRef.on('value', function(snapshot) {
		                self.subCategory = snapshot.val();
		                self.isSubCategory = true;
		            });

	            }else{
	                self.isSubCategory = false;
	                self.finalType = null;
	            }
	  		},
	  		receivedMessage: function(message, id){
	  			if(id == "textHU"){
	  				this.textHU = message;
	  			}else{
	  				this.textEN = message;
	  			}
	  		},
	  		updateDataInDB: function(type, id){
	  			let date = getCurrentDate();
	  			let dbRef;

	  			if(this.finalType != null){
	  				dbRef = this.database.ref('products/'+type+"/"+this.finalType+'/'+id);
	  			}else{
	  				dbRef = this.database.ref('products/'+type+"/"+id);
	  			}

	  			dbRef.update({
				    date: date,
				    nameHU: this.nameHU,
				    nameEN: this.nameEN,
				    linkHU: this.linkHU,
				    linkEN: this.linkEN,
				    priceHU : this.priceHU,
				    materialHU: this.materialHU,
				    materialEN: this.materialEN,
				    textHU: this.textHU,
				    textEN: this.textEN,
				    img: this.img_file,
				    manufacturer: this.manufacturer,
				    strength: this.strength,
				    size: this.size,
				    visible: this.visible
				});

				alert("A termék módosult!");
	  		},
	    	sendDataToDB: function(e){
	    		e.preventDefault();

	    		let id = Math.floor((Math.random() * 99999) + 1);
	    		let date = getCurrentDate();
	    		let img = document.getElementById("img").value;
	    		let dbRef;

	    		if(img){
	    			var self = this;
					let file = document.getElementById("img").files[0];
					new Compressor(file, {
					    quality: 0.6,
					    success(result) {
					      	self.storageRef.child("products/"+self.img_file).put(result).then(function(snapshot) {
							  	console.log('File uploaded!');
							});
					    },
					    error(err) {
					      	console.log(err.message);
					    },
					});
				}

				if(this.finalType != null){
	  				dbRef = this.database.ref('products/'+this.typeEN+"/"+this.finalType+'/'+id);
	  			}else{
	  				dbRef = this.database.ref('products/'+this.typeEN+"/"+id);
	  			}

	    		dbRef.set({
	    			date: date,
				    nameHU: this.nameHU,
				    nameEN: this.nameEN,
				    linkHU : this.linkHU,
				    linkEN: this.linkEN,
				    priceHU : this.priceHU,
				    materialHU: this.materialHU,
				    materialEN: this.materialEN,
				    textHU: this.textHU,
				    textEN: this.textEN,
				    img: this.img_file,
				    manufacturer: this.manufacturer,
				    strength: this.strength,
				    size: this.size,
				    visible: this.visible
				});

	    		this.nameHU = "";
			    this.nameEN = "";
			    this.linkHU = "";
			    this.linkEN = "";
			    this.priceHU = "";
			    this.materialHU = "";
			    this.materialEN = "";
			    this.textHU = "";
			    this.textEN = "";
			    this.img = "";
			    this.manufacturer = "";
			    this.strength = "";
			    this.size = "";
	    	},

	    	getDataFromDB: function(type,subCategory, id){
	    		let ref;

	    		if(this.isSubCategory == true){
	    			this.typeEN = type;
	    			this.finalType = subCategory;
	    			ref = this.database.ref("products/"+type+"/"+subCategory+'/'+id);
	    		}else{
	    			this.typeEN = type;
	    			ref = this.database.ref("products/"+type+"/"+id);
	    		}
	    		
	    		let self = this;
	    		ref.on('value', function(snapshot) {
                	self.nameHU = snapshot.val().nameHU;
                    self.nameEN = snapshot.val().nameEN;
                    self.priceHU = snapshot.val().priceHU;
                    self.linkHU = snapshot.val().linkHU;
                    self.linkEN = snapshot.val().linkEN;
                    self.materialHU = snapshot.val().materialHU;
                    self.materialEN = snapshot.val().materialEN;
                    self.textHU = snapshot.val().textHU;
                    self.textEN = snapshot.val().textEN;
                    self.img_file = snapshot.val().img;
                    self.size = snapshot.val().size;
                    self.strength = snapshot.val().strength;
                    self.manufacturer = snapshot.val().manufacturer;
                    self.visible = snapshot.val().visible;
                });
	    	}
	  	}
    };
</script>


// WEBPACK FOOTER //
// src/components/NewProduct.vue